import React, { useEffect } from "react";
import "./Footer.css";
import { Nav, NavLink } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  faFacebookF,
  faLinkedinIn,
  faTwitter,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { appSetup } from "../../features/master/masterSlice";
import { getSocialmedia } from "../../features/socialmedia/Slice";
const Footer = () => {
  const location = useLocation();

  const socialIcons = [
    { icon: faLinkedinIn, link: "https://www.linkedin.com" },
    { icon: faFacebookF, link: "https://www.facebook.com" },
    { icon: faTwitter, link: "https://www.twitter.com" },
    { icon: faInstagram, link: "https://www.instagram.com" },
  ];

  const dispatch = useDispatch();
  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  const socialLink = useSelector((state) => state.socialmedia.addSocialmedia);

  useEffect(() => {
    dispatch(getSocialmedia());
  }, [dispatch]);
  const isSignIn = useSelector((state) => state.auth.is_signin);

  return (
    <>
      <section className="Footer">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-lg-3 col-sm-12">
              <div className="logo_holder">
                <img
                  // src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
                  src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                  className="logo_img"
                />
              </div>
            </div>
            <div className="col-xl-3 col-lg-3 col-sm-4 col-7">
              <div className="col_div">
                <p className="footer_section_title">Quick Links</p>
                <Nav>
                  <div className="first_nav_div">
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/"
                        className={location.pathname === "/" ? "active" : ""}
                      >
                        Home
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/categories"
                        className={
                          location.pathname === "/categories" ? "active" : ""
                        }
                      >
                        Categories
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/about-us"
                        className={
                          location.pathname === "/about-us" ? "active" : ""
                        }
                      >
                        About Us
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/contact-us"
                        className={
                          location.pathname === "/contact-us" ? "active" : ""
                        }
                      >
                        Contact Us
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/privacy-policy"
                        className={
                          location.pathname === "/privacy-policy"
                            ? "active"
                            : ""
                        }
                      >
                        Privacy Policy
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/terms-conditions"
                        className={
                          location.pathname === "/terms-conditions"
                            ? "active"
                            : ""
                        }
                      >
                        Terms & Conditions
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/blogs"
                        className={
                          location.pathname === "/blogs" ? "active" : ""
                        }
                      >
                        Blogs
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink as={Link} to="/faq">
                        FAQs
                      </NavLink>
                    </Nav.Item>
                  </div>
                </Nav>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-sm-5 order-sm-3 order-4 ">
              <div className="col_div">
                <p className="footer_section_title">Customer Support</p>

                <div className="footer_info_div">
                  <p className="info_text">Email: {app_setup?.email}</p>
                  <p className="info_text">Phone: {app_setup?.contact_no}</p>
                </div>

                <p className="footer_section_sub_title">
                  Phone for Corporate Queries{" "}
                </p>

                <div className="footer_info_div">
                  <p className="info_text">
                    Phone: {app_setup?.alt_contact_no}
                  </p>
                </div>

                <p className="footer_section_sub_title">Address</p>

                <div className="footer_info_div">
                  <p className="info_text">{app_setup?.address}</p>
                </div>
              </div>
            </div>

            <div className="col-xl-2 col-lg-2 col-sm-3 col-5 order-sm-4 order-3">
              <div className="col_div">
                <p className="footer_section_title">Social Links</p>

                <div className="icons_holder">
                  {socialLink.map((item, index) => (
                    <div className="img_holder">
                      <a
                        key={index}
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {/* <FontAwesomeIcon
                          icon={item.icon}
                          alt={`social-icon-${index}`}
                          className="icon_img"
                        /> */}
                        
                        <img
                          src={process.env.REACT_APP_IMG_URL + item?.image}
                          className="icon_class"
                        />
                      </a>
                      
                    </div>
                    
                     
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="footer_text_div">
            <p className="footer_text">
              © 2026 Majesty Mattress All Rights Reserved | Developed by{" "}
              <Link to="https://profcymaglobal.com" target="_blank">
                Profcyma Solutions Pvt Ltd
              </Link>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
